exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".askForCodeForm__codeInput___XUSOw {\n  color: #6b6767;\n  padding: 8px;\n  border-radius: 5px;\n  border: 1px solid #A7A7A7;\n  font-size: 20px;\n  outline: none;\n  text-align: center; }\n", ""]);

// exports
exports.locals = {
	"codeInput": "askForCodeForm__codeInput___XUSOw"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Forms/AskForCode/askForCodeForm.scss
// module id = 654
// module chunks = 0